import styled from '@emotion/styled';
import { StyledLink } from '~/shared/styles/Link';

type StyledM70Props = {
    textColor?: string;
    mediaType: 'video' | 'image';
};

export const StyledM70 = styled.div<StyledM70Props>(({ mediaType }) => ({
    position: 'relative',
    width: '100%',
    boxSizing: 'border-box',
    display: 'grid',
    gap: 5,
    aspectRatio: mediaType === 'video' ? '3.75' : '2.5',

    [` ${StyledLink}`]: {
        display: 'block',
        height: '100%',
    },

    ['img']: {
        objectFit: 'cover',
    },

    div: {
        position: 'relative',
    },
}));
